var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "arrange-images", style: { padding: _vm.activePadding } },
    [
      _c("div", { staticClass: "arrange-images-container" }, [
        _vm.propsData.imgType === 1
          ? _c("div", { staticClass: "show-type1 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img w100 cover",
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.propsData.imgType === 2
          ? _c("div", { staticClass: "show-type2 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img cover",
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.propsData.imgType === 3
          ? _c("div", { staticClass: "show-type3 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img cover",
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.propsData.imgType === 4
          ? _c("div", { staticClass: "show-type4 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img cover",
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.propsData.imgType === 5
          ? _c("div", { staticClass: "show-type5 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img w100 cover",
                        class: { row2: index === 0 },
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm.propsData.imgType === 6
          ? _c("div", { staticClass: "show-type6 w100" }, [
              _vm.propsData.activity && _vm.propsData.activity.length > 0
                ? _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.propsData.activity, function (item, index) {
                      return _c("img", {
                        key: index,
                        staticClass: "advert-img w100 cover",
                        attrs: { src: item.pic },
                      })
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }